import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { deleteMenu, getMenuById } from "../../api/MenuService";
import { getErrorMessage } from "../../utils/errorHandler";
import StatusBadge from "../Shared/StatusBadge";
import RecordActions from "../Shared/RecordActions";
import FullPageLoader from "../../common/FullPageLoader";
export default function MenuView() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const id = location.state?.menuId || params.id;
  const [menu, setMenu] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const fetchMenu = async () => {
    setLoading(true);
    try {
      setError("");
      const res = await getMenuById(id);
      setMenu(res?.data?.data || res?.data || res || null);
    } catch (error) {
      setError(getErrorMessage(error));
      setMenu(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchMenu();
    }
  }, [id]);
  if (loading) {
    return <FullPageLoader text="Loading menu..." />;
  }
  if (!menu) {
    return (
      <div className="text-center mt-2">
        <h6>{error || "Menu Not Found"}</h6>
      </div>
    );
  }

  const handleDelete = async () => {
    if (!menu?._id || !window.confirm("Are you sure you want to delete this menu?")) {
      return;
    }

    try {
      await deleteMenu(menu._id);
      alert("Menu deleted successfully");
      navigate("/menu");
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };

  return (
    <div
    >
      <div
        className="conatiner-fluid p-4"
       
      >
        <div className="card p-3">
          <RecordActions
            onBack={() => navigate("/menu")}
            onEdit={() =>
              navigate(`/menu/edit/${menu._id}`, {
                state: { menuId: menu._id },
              })
            }
            onDelete={handleDelete}
          />
          <h5 className="fw-bold mb-3">
            Menu Details - {menu.name}
          </h5>
          {/* ROW 1 */}
          <div className="row mb-2">
            <div className="col-4 px-1">
              <strong>Slug:</strong> {menu.slug || "-"}
            </div>
            <div className="col-4 px-1">
              <strong>Type:</strong> {menu.type || "-"}
            </div>
            <div className="col-4 px-1">
              <strong>Visible:</strong> {menu.visible ? "Yes" : "No"}
            </div>
          </div>
          {/* ROW 2 */}
          <div className="row">
            <div className="col-4 px-1">
              <strong>Order:</strong> {menu.order ?? "-"}
            </div>
            <div className="col-4 px-1">
              <strong>Parent:</strong>{" "}
              {menu.parentId?.name || menu.parentId?.title || menu.parentId?._id ||
                (typeof menu.parentId === "string" ? menu.parentId : "-")}
            </div>
            <div className="col-4 px-1">
              <strong>Status:</strong> <StatusBadge status={menu.status} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
